interface StringEnumItem {
  title: { [key: string]: string }; // translated
  value: string;
}

interface NumberEnumItem {
  title: { [key: string]: string }; // translated
  value: number;
}

export class SalutationEnum {
  public static MALE: NumberEnumItem = {title: {'de': 'Herr', 'en': 'Mister'}, value: 0};
  public static FEMALE: NumberEnumItem = {title: {'de': 'Frau', 'en': 'Miss'}, value: 1};
  public static NONE: NumberEnumItem = {title: {'de': 'Divers', 'en': 'Divers'}, value: 2};
}

export class TitleEnum {
  public static NONE = {title: '-', value: 0};
}

export class AddressTypeEnum {
  public static NONE: NumberEnumItem = {title: {'de': '-', 'en': '-'}, value: 0};
  public static PRIVATE: NumberEnumItem = {title: {'de': 'Privat', 'en': 'Private'}, value: 1};
  public static COMMERCIAL_BUSINESS: NumberEnumItem = {title: {'de': 'Gewerblich/Dienstlich', 'en': 'Commercial/Business'}, value: 2};
}

export class VisitorSegmentEnum {
  public static ABBAU = 'Abbau';
  public static AUFBAU = 'Aufbau';
  public static AUSSTELLER = 'Aussteller';
  public static BESUCHER = 'Besucher';
  public static PRESSE = 'Presse';
  public static VIP = 'VIP';
}

export class PaymentTypeEnum {
  // values ignored here... values === names
  public static creditcard: StringEnumItem = {title: {'de': 'Kreditkarte / Debitkarte', 'en': 'Credit card'}, value: 'creditcard'};
  // public static ['google-pay']: StringEnumItem = {title: {'de': 'Google Pay', 'en': 'Google Pay'}, value: 'google-pay'};
  public static applepay: StringEnumItem = {title: {'de': 'Apple Pay', 'en': 'Apple Pay'}, value: 'applepay'};
  // public static invoice: StringEnumItem = {title: {'de': 'Rechnung', 'en': 'Rechnung'}, value: 'invoice'};
  // public static ['klarna']: StringEnumItem = {title: {'de': 'Klarna (Sofort bezahlen)', 'en': 'Klarna (Pay now)'}, value: 'klarna-pay-now'};
  // public static ['klarna-pay-now']: StringEnumItem = {title: {'de': 'Klarna (Sofort bezahlen)', 'en': 'Klarna (Pay now)'}, value: 'klarna-pay-now'};
  public static paypal: StringEnumItem = {title: {'de': 'PayPal', 'en': 'PayPal'}, value: 'paypal'};
  // public static paydirekt: StringEnumItem = {title: {'de': 'PayDirekt', 'en': 'PayDirekt'}, value: 'paydirekt'};
  // public static ['ratepay-directdebit']: StringEnumItem = {title: {'de': 'ratepay-directdebit', 'en': 'ratepay-directdebit'}, value: 'ratepay-directdebit'};
  // public static ['ratepay-invoice']: StringEnumItem = {title: {'de': 'RatePay (Rechnung)', 'en': 'RatePay (Invoice)'}, value: 'ratepay-invoice'};
  public static sepa: StringEnumItem = {title: {'de': 'SEPA Lastschrift', 'en': 'SEPA'}, value: 'sepa'};
  public static paydirekt: StringEnumItem = {title: {'de': 'paydirekt', 'en': 'paydirekt'}, value: 'paydirekt'};

  public static isAsync(type: string): boolean {
    return ['paypal', 'paydirekt', 'klarna-pay-now'].indexOf(type) >= 0;
  }
}

export class LanguageEnum {
  public static DE: string = 'de';
  public static EN: string = 'en';
  public static DEFAULT: string = 'de';
}

export class OrderQuantityRestrictionEnum {
  public static POSITION: number = 1;
  public static ALL_ORDERS: number = 2;
  public static ORDER: number = 3;
}

export class OrderCheckoutStepEnum {
  public static PERSONALIZATION: number = 0;
  public static PUBLIC_TRANSPORT: number = 1;
  public static PAYMENT: number = 2;
  public static REVIEW: number = 3;
}

export class ProductQuantityErrorEnum {
  public static ERROR_CODE_MAX_LIMIT_EXCEEDED = 11;
  public static ERROR_CODE_MIN_LIMIT_NOT_REACHED = 12;
}

export class PaymentInfoFormEnum {
  public static creditcard = 'credit-card-form';
  public static ['google-pay'] = '';
  public static applepay = '';
  public static invoice = '';
  // public static ['klarna-pay-now'] = '';
  public static paypal = '';
  // public static paydirekt = '';
  // public static ['ratepay-directdebit'] = '';
  // public static ['ratepay-invoice'] = '';
  public static sepa = 'sepa-form';
}

export class PublicLinks {
  public static PRIVACY_STATEMENT = {
    de: 'https://www.messe-stuttgart.de/datenschutzerklaerung/',
    en: 'https://www.messe-stuttgart.de/en/data-protection-declaration',
  };
  public static TERMS_AND_CONDITIONS = {
    de: 'https://www.messe-stuttgart.de/agb/',
    en: 'https://www.messe-stuttgart.de/en/exhibitors/registration',
  };
}
